$(function () {
  // Scrollspy
  var sidebarEl = $('.sidebar'),
      sidebarWidth = sidebarEl.width(),
      navEl = $('.sidebar .nav');
    
  // navEl.css('width', sidebarWidth);
  // $(window).resize(function () {
  //   sidebarWidth = sidebarEl.width();
  //   navEl.css('width', sidebarWidth);
  // });
  

  // Smooth scrolling when clicking an anchor link
  var $root = $('html, body');
  $('.nav a, .navbar a').click(function() {
    var href = $.attr(this, 'href');
    $root.animate({
      scrollTop: $(href).offset().top - 106
    }, 500, function () {
      window.location.hash = href;
    });
    return false;
  });
  
  $(".sidebar").stick_in_parent({
    offset_top: 100,
  });
  
  $('.tooltip-init').tooltip();
  // $('.tooltip-init').tooltip('show');
});
